module.exports = __webpack_public_path__ + "static/media/twilio.ed2c1b56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/twilio.png
// module id = 207
// module chunks = 0